import React, { useState, useEffect } from 'react';
import Dashboard from '../components/Dashboard';

function DashboardPage() {
    const [messages, setMessages] = useState([]);
    const [devices, setDevices] = useState([]);
    const token = localStorage.getItem('token'); // Retrieve token from localStorage or context

    useEffect(() => {
        // Fetch messages and devices concurrently
        async function fetchData() {
            try {
                // Fetch messages
                const messagesResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/messages`);
                const messagesData = await messagesResponse.json();
                setMessages(messagesData);

                // Fetch devices
                const devicesResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/devices`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const devicesData = await devicesResponse.json();
                setDevices(devicesData);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        fetchData();
    }, [token]);

    return (
        <div>
            <h1>Приборная доска</h1>
            <Dashboard messages={messages} devices={devices} /> {/* Pass both messages and devices */}
        </div>
    );
}

export default DashboardPage;
